"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThrottle = void 0;
var useThrottle_1 = require("./useThrottle");
Object.defineProperty(exports, "useThrottle", { enumerable: true, get: function () { return useThrottle_1.useThrottle; } });
//# sourceMappingURL=index.js.map